/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface MetricsDashboardRetrieveRequest {
    teamSlug: string;
}

export interface MetricsFindingsMetricsRetrieveRequest {
    teamSlug: string;
}

export interface MetricsLeaksDashboardRetrieveRequest {
    teamSlug: string;
}

/**
 * 
 */
export class MetricsApi extends runtime.BaseAPI {

    /**
     * Get dashboard statistics for a team including: - Total number of findings - Findings by severity - Findings by status - Asset counts (domains, subdomains, IPs, ports) - Organization risk score - Total dataleaks and recent code leaks - Top 3 vulnerable assets - Recent 3 findings - Credentials statistics
     */
    async metricsDashboardRetrieveRaw(requestParameters: MetricsDashboardRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling metricsDashboardRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/metrics/{team_slug}/dashboard`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get dashboard statistics for a team including: - Total number of findings - Findings by severity - Findings by status - Asset counts (domains, subdomains, IPs, ports) - Organization risk score - Total dataleaks and recent code leaks - Top 3 vulnerable assets - Recent 3 findings - Credentials statistics
     */
    async metricsDashboardRetrieve(requestParameters: MetricsDashboardRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.metricsDashboardRetrieveRaw(requestParameters, initOverrides);
    }

    /**
     * Get key metrics including severity counts, credentials stats, and dataleaks numbers. Follows team-based filtering pattern and proper error handling.
     */
    async metricsFindingsMetricsRetrieveRaw(requestParameters: MetricsFindingsMetricsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling metricsFindingsMetricsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/metrics/{team_slug}/findings-metrics`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get key metrics including severity counts, credentials stats, and dataleaks numbers. Follows team-based filtering pattern and proper error handling.
     */
    async metricsFindingsMetricsRetrieve(requestParameters: MetricsFindingsMetricsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.metricsFindingsMetricsRetrieveRaw(requestParameters, initOverrides);
    }

    /**
     * Get comprehensive leaks dashboard statistics including: - Total counts for different leak types - Leaks trend analysis - Leaks by severity and status - Leaks by type distribution - Most leaked emails - Recent leaks list - Monthly trends
     */
    async metricsLeaksDashboardRetrieveRaw(requestParameters: MetricsLeaksDashboardRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling metricsLeaksDashboardRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/metrics/{team_slug}/leaks-dashboard`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get comprehensive leaks dashboard statistics including: - Total counts for different leak types - Leaks trend analysis - Leaks by severity and status - Leaks by type distribution - Most leaked emails - Recent leaks list - Monthly trends
     */
    async metricsLeaksDashboardRetrieve(requestParameters: MetricsLeaksDashboardRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.metricsLeaksDashboardRetrieveRaw(requestParameters, initOverrides);
    }

}
